import * as Yup from 'yup';
import { cpfValidator } from '../../utils/CpfValidator';
import { cnpjValidator } from '../../utils/CnpjValidator';

export const PessoaFisicaValidation = Yup.object({
  numeroCartao: Yup.string()
    .required('Número do cartão é obrigatório')
    .test(
      'valid-card-length',
      'Verifique se o número do cartão está correto',
      value => {
        if (!value) return false;
        return value.length >= 10 && value.length <= 30;
      }
    )
    .test(
      'only-numbers',
      'O número do cartão deve conter apenas números',
      value => {
        if (!value) return false;
        return /^\d+$/.test(value);
      }
    ),

  cpf: Yup.string()
    .required('CPF é obrigatório')
    .test(
      'valid-cpf-length',
      'Verifique se o CPF está correto',
      value => {
        if (!value) return false;
        return value.length === 11;
      }
    )
    .test(
      'cpf-valid',
      'Verifique se o CPF está correto',
      function (value) {
        return cpfValidator(value || '');
      }
    ),
});

export const PessoaJuridicaValidation = Yup.object({
  codigoEmpresa: Yup.string()
    .required('Código da empresa é obrigatório')
    .test(
      'valid-code-length',
      'Verifique se o código da empresa está correto',
      value => {
        if (!value) return false;
        return value.length >= 3 && value.length <= 20;
      }
    )
    .test(
      'only-numbers',
      'O código da empresa deve conter apenas números',
      value => {
        if (!value) return false;
        return /^\d+$/.test(value);
      }
    ),

  // SR-2406: contratos PJ com pagador PF usam o CPF do pagador neste campo,
  // por isso o documento pode ser CNPJ (14 caracteres, alfanumérico desde 2026)
  // ou CPF (11 dígitos numéricos)
  cnpj: Yup.string()
    .required('CPF ou CNPJ é obrigatório')
    .test(
      'valid-cnpj-chars',
      'O CNPJ deve conter apenas letras e números e o CPF apenas números',
      value => {
        if (!value) return false;
        return /^[0-9A-Za-z]+$/.test(value);
      }
    )
    .test(
      'valid-cnpj-length',
      'Verifique se o CPF ou CNPJ está correto',
      value => {
        if (!value) return false;
        return value.length === 14 || value.length === 11;
      }
    )
    .test(
      'cnpj-valid',
      'Verifique se o CPF ou CNPJ está correto',
      function (value) {
        if (!value) return false;
        return value.length === 11 ? cpfValidator(value) : cnpjValidator(value);
      }
    ),
});

export const IdentificacaoValidation = {
  pessoaFisica: PessoaFisicaValidation,
  pessoaJuridica: PessoaJuridicaValidation,
};